{
  "markread": "Tutte lette",
  "newest": "Recenti",
  "unread": "Non lette",
  "starred": "Contrassegnate",
  "tags": "Etichette",
  "alltags": "Tutte le etichette",
  "timestamp": "{0,date} {0,time}",
  "days": "{0,plural,one {1 ora},other {# ore}} fa",
  "minutes": "{0,plural,one {1 minuto},other {# minuti}} fa",
  "seconds": "{0,plural,one {1 secondo},other {# secondi}} fa",
  "star": "Contrassegna",
  "unstar": "Togli contrassegno",
  "mark": "Segna come letta",
  "unmark": "Segna come non letta",
  "load_img": "Caricare le immagini",
  "open_window": "Apri",
  "searchbutton": "Ricerca",
  "sources": "Fonti",
  "source_add": "Aggiungi una fonte",
  "source_opml": "o importa un file OPML / Google reader",
  "source_export": "Esporta fonti",
  "source_edit": "modifica",
  "source_delete": "cancella",
  "source_warn": "Vuoi veramente eliminare questa fonte?",
  "source_new": "Nuova fonte",
  "source_title": "Titolo",
  "source_tags": "Etichette",
  "source_comma": "separate da una virgola",
  "source_select": "seleziona il tipo di fonte",
  "source_type": "Tipo",
  "source_save": "salva",
  "source_cancel": "annulla",
  "no_entries": "Nessuna pubblicazione",
  "more": "Caricare altre pubblicazioni",
  "login": "Accedi",
  "login_username": "Nome utente",
  "login_password": "Password",
  "no_title": "Senza titolo",
  "error_star_item": "Non è possibile contrassegnare/togliere il contrassegno per l'elemento:",
  "error_mark_item": "Impossibile segnare l'elemento come letto/non letto:",
  "article_actions": "Azioni",
  "close_entry": "Chiudi",
  "info_url_copied": "URL copiato negli appunti.",
  "error_share_native": "Impossibile condividere l'elemento.",
  "error_share_native_abort": "Impossibile condividere l'articolo – non ci sono obiettivi di condivisione o l'hai cancellato.",
  "error_configuration": "Impossibile caricare la configurazione.",
  "error_invalid_subsection": "Sottosezione non valida:",
  "error_offline_storage": "Errore di archiviazione offline: {0}. Il ricaricamento può aiutare. Disabilitazione la modalità offline per ora.",
  "error_sync": "Impossibile sincronizzare le ultime modifiche dal server:",
  "error_refreshing_source": "Impossibile aggiornare le fonti:",
  "error_saving_color": "Impossibile salvare un nuovo colore:",
  "error_loading_stats": "Impossibile caricare le statistiche di navigazione:",
  "error_loading": "Errore di caricamento:",
  "error_logout": "Impossibile uscire:",
  "error_mark_items": "Impossibile contrassegnare tutti gli elementi visibili:",
  "error_unknown_source": "Identificazione della fonte sconosciuta:",
  "error_unknown_tag": "Etichetta sconosciuta:",
  "error_load_tags": "Impossibile caricare le etichette:",
  "error_delete_source": "Impossibile eliminare l'origine:",
  "error_add_source": "Impossibile aggiungere la fonte:",
  "error_session_expired": "Sessione scaduta",
  "app_reload": "Ricarica",
  "app_update": "selfoss è stato aggiornato, si prega di ricaricare",
  "sources_refreshed": "Fonti aggiornate",
  "reload_list": "Ricarica l'elenco",
  "streamerror": "Nessun elemento caricato, ricaricare?",
  "error": "Si è verificato un errore",
  "source_refresh": "Aggiorna questa fonte",
  "source_last_post": "Ultimo elemento visto",
  "source_saved": "Salvato",
  "source_pwd_placeholder": "Non cambiato",
  "source_autotitle_hint": "Lascia vuoto per recuperare il titolo",
  "source_filter": "Filtro",
  "loginbutton": "Accedi",
  "logoutbutton": "Esci",
  "settingsbutton": "Impostazioni",
  "refreshbutton": "Aggiorna le fonti",
  "searchremove": "Nascondi la ricerca",
  "search_label": "Termine di ricerca",
  "share_copy_label": "Copia il collegamento negli appunti",
  "share_wordpress_label": "Condividi su WordPress",
  "share_wallabag_label": "Salva in Wallabag",
  "share_pocket_label": "Salva in Pocket",
  "share_facebook_label": "Condividi su Facebook",
  "share_twitter_label": "Condividi su Twitter",
  "share_diaspora_label": "Condividi su Diaspora",
  "share_native_label": "Condividi",
  "next": "Avanti",
  "hours": "{0,plural,one {1 ora},other {# ore}} fa",
  "offline_count": "Elementi disponibili localmente",
  "online_count": "Articoli disponibili sul server",
  "filter": "Filtra",
  "share_mail_label": "Condividi via posta elettronica",
  "login_offline": "Archiviazione offline",
  "login_invalid_credentials": "Nome utente o password errato",
  "error_offline_storage_not_available": "Non è disponibile memoria offline. Assicurati che il tuo browser web {0} supporti IdexedDB API {1} e che tu non stia utilizzando la modalità incognito su browser basati su Google Chrome.",
  "error_edit_source": "Impossibile salvare le modifiche alla fonte:",
  "error_unwritable_logs": "Impossibile scrivere i log.",
  "error_check_system_logs": "Si è verificato un errore, controlla i tuoi log di sistema.",
  "error_check_log_file": "Si è verificato un errore, controlla il file di log «{0}».",
  "offline_navigation_unavailable": "Al momento non è possibile modificare etichette e fonti nella modalità fuori linea.",
  "article_reading_time": "{0} min letti",
  "experimental": "Sperimentale",
  "source_go_to_settings": "Apri nelle impostazioni",
  "sources_loading": "Caricamento delle fonti…",
  "source_deleting": "Eliminazione della fonte…",
  "source_browse": "Sfoglia",
  "source_params_loading": "Caricamento dei parametri…",
  "no_sources": "Nessuna fonte configurata.",
  "source_warn_cancel_dirty": "Scartare le modifiche non salvate?",
  "source_menu": "Più azioni",
  "sources_leaving_unsaved_prompt": "Esci dalle impostazioni con delle modifiche della fonte non salvate?",
  "tag_change_color_button_title": "Cambia il colore",
  "entries_loading": "Caricamento delle pubblicazioni…",
  "source_saving": "Salvataggio delle modifiche alla fonte…",
  "error_unauthorized": "Per favore {link_begin} connettiti{link_end} per continuare.",
  "login_in_progress": "Tentativo di connessione…",
  "login_error_generic": "Connessione impossibile: {errorMessage}"
}
